// import type { PartialDeep } from 'type-fest/source/partial-deep';

import { Lead } from '@backend/src/frontend-mongo-interfaces/mongoose.gen';
import {
  LeadContinueArgsType,
  LeadContinueReturnType,
} from '@backend/src/endpoints/leadContinue';
import { GetShareLinkResponse } from '@backend/src/endpoints/leadGetShareLink';
import {
  LeadAuthArgsType,
  LeadAuthReturnType,
} from '@backend/src/endpoints/leadReauth';
import type { CredentialsResponse } from '@backend/src/services/sts';
import logger from 'logger';
import { API_ROOT } from 'utils';

const sharedHeaders = {
  'Content-Type': 'application/json',
};

const isResponseNotOk = (response: Response) =>
  ['4', '5'].includes(`${response.status}`[0]) || !response.ok;

export const postContinue = async ({
  encodedID,
  encodedToken,
}: LeadContinueArgsType): Promise<LeadContinueReturnType> => {
  const response = await fetch(`${API_ROOT}/continue`, {
    method: 'POST',
    headers: {
      ...sharedHeaders,
    },
    body: JSON.stringify({
      encodedID,
      encodedToken,
    }),
  });
  return response.json();
};

export const postReauth = async ({
  email,
  lastName,
}: LeadAuthArgsType): Promise<LeadAuthReturnType> => {
  const response = await fetch(`${API_ROOT}/reauth`, {
    method: 'POST',
    headers: {
      ...sharedHeaders,
    },
    body: JSON.stringify({
      email,
      lastName,
    }),
  });

  if (isResponseNotOk(response)) {
    logger.error('postReauth response not ok', { response });
    throw response;
  }

  return response.json();
};

export const getCredentials = async ({
  activeLeadID,
}: {
  activeLeadID: string;
}): Promise<NonNullable<CredentialsResponse>> => {
  const response = await fetch(`${API_ROOT}/lead/${activeLeadID}/credentials`, {
    method: 'POST',
    headers: sharedHeaders,
  });

  if (isResponseNotOk(response)) {
    logger.error('getCredentials response not ok', { response });
    throw response;
  }

  return response.json();
};

export const getShareLink = async ({
  activeLeadID,
}: {
  activeLeadID: string;
}): Promise<GetShareLinkResponse> => {
  const response = await fetch(`${API_ROOT}/lead/${activeLeadID}/shareLink`, {
    method: 'POST',
    headers: sharedHeaders,
  });

  if (isResponseNotOk(response)) {
    logger.error('getShareLink response not ok', { response });
    throw response;
  }

  return response.json();
};

export const leadGet = async ({
  activeLeadID,
}: {
  activeLeadID: string;
}): Promise<Lead> => {
  const response = await fetch(`${API_ROOT}/lead/${activeLeadID}`, {
    headers: sharedHeaders,
  });

  if (isResponseNotOk(response)) {
    logger.error('getLead response not ok', { response });
    throw response;
  }

  return response.json();
};
